// Merchant-facing RTO risk band.
//
// NETRA scores each order into one of five internal bands
// (RED / ORANGE / YELLOW / GREEN / GREY). Merchants see a simpler 3-level
// scale — High / Medium / Low — plus a separate "New buyer" state (GREY),
// which is an absence of history rather than a risk level.
//
//   High     <- RED
//   Medium   <- ORANGE, YELLOW
//   Low      <- GREEN
//   New buyer<- GREY
//
// Single source of truth for the mapping, the display config (label/colour),
// and the list-filter options so the badge, card, filter and any future
// surface stay in sync.

// Display config per merchant band. `color` is an MUI palette name (for <Chip
// color=...>); `hex` is the solid colour for the list pill.
export const RTO_BAND3 = {
  HIGH: { key: 'HIGH', label: 'High', color: 'error', hex: '#d32f2f' },
  MEDIUM: { key: 'MEDIUM', label: 'Medium', color: 'warning', hex: '#ed6c02' },
  LOW: { key: 'LOW', label: 'Low', color: 'success', hex: '#2e7d32' },
  NEW: { key: 'NEW', label: 'New buyer', color: 'default', hex: '#757575' },
}

// NETRA band (RED/ORANGE/YELLOW/GREEN/GREY) -> merchant 3-band display config.
export const rtoBand3 = (band) => {
  switch (band) {
    case 'RED':
      return RTO_BAND3.HIGH
    case 'ORANGE':
    case 'YELLOW':
      return RTO_BAND3.MEDIUM
    case 'GREEN':
      return RTO_BAND3.LOW
    case 'GREY':
      return RTO_BAND3.NEW
    default:
      return RTO_BAND3.NEW
  }
}

// Merchant 3-band key -> the NETRA band values it covers. Used to translate a
// filter selection into the order/search `netraRto.band` `in` query.
export const RTO_BAND3_TO_NETRA = {
  HIGH: ['RED'],
  MEDIUM: ['ORANGE', 'YELLOW'],
  LOW: ['GREEN'],
  NEW: ['GREY'],
}

// Options for the shipment-list "RTO Risk" select (value = merchant 3-band key).
export const RTO_BAND3_OPTIONS = [
  { label: 'High', value: 'HIGH' },
  { label: 'Medium', value: 'MEDIUM' },
  { label: 'Low', value: 'LOW' },
  { label: 'New buyer', value: 'NEW' },
]
